import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Factory, Play, Check } from 'lucide-react';
import { Can } from '@/components/Can';
import { Button, DataTable, EmptyState, PageHeader, StateBadge } from '@/components/ui';
import { api } from '@/lib/api';
export function WorkOrdersPage() {
    const qc = useQueryClient();
    const list = useQuery({
        queryKey: ['work-orders'],
        queryFn: async () => (await api.get('/manufacturing/work-orders/')).data,
    });
    const start = useMutation({
        mutationFn: async (id) => api.post(`/manufacturing/work-orders/${id}/start/`),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['work-orders'] }),
    });
    const complete = useMutation({
        mutationFn: async ({ id, produced_quantity }) => api.post(`/manufacturing/work-orders/${id}/complete/`, { produced_quantity }),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['work-orders'] }),
    });
    return (_jsxs("div", { className: "space-y-6", children: [_jsx(PageHeader, { title: "Work orders", description: "BOM-driven production runs. Materials and finished goods flow through the inventory ledger." }), _jsx(DataTable, { rows: list.data, loading: list.isLoading, rowKey: (r) => r.id, empty: _jsx(EmptyState, { icon: _jsx(Factory, { className: "h-6 w-6" }), title: "No work orders yet", description: "Define a BOM, then create a work order to schedule a production run." }), columns: [
                    { key: 'ref', header: 'Reference', render: (w) => _jsx("code", { className: "font-mono", children: w.reference }) },
                    { key: 'bom', header: 'BOM', render: (w) => _jsx("span", { className: "font-mono text-xs text-muted-foreground", children: w.bom_code }) },
                    { key: 'out', header: 'Output SKU', render: (w) => _jsx("code", { className: "font-mono", children: w.output_sku }) },
                    {
                        key: 'planned', header: 'Planned', align: 'right',
                        render: (w) => _jsx("span", { className: "font-mono", children: w.quantity_planned }),
                    },
                    {
                        key: 'produced', header: 'Produced', align: 'right',
                        render: (w) => _jsx("span", { className: "font-mono", children: w.quantity_produced }),
                    },
                    { key: 'state', header: 'State', render: (w) => _jsx(StateBadge, { state: w.state }) },
                    {
                        key: 'actions', header: '', align: 'right',
                        render: (w) => (_jsx(Can, { code: "manufacturing.workorder.manage", children: _jsxs("div", { className: "flex justify-end gap-2", children: [w.state === 'draft' && (_jsx(Button, { size: "sm", variant: "outline", leftIcon: _jsx(Play, { className: "h-3 w-3" }), onClick: () => start.mutate(w.id), children: "Start" })), w.state === 'in_progress' && (_jsx(Button, { size: "sm", leftIcon: _jsx(Check, { className: "h-3 w-3" }), onClick: () => {
                                            const qty = prompt(`Produced quantity for ${w.reference}?`, w.quantity_planned);
                                            if (qty)
                                                complete.mutate({ id: w.id, produced_quantity: qty });
                                        }, children: "Complete" }))] }) })),
                    },
                ] })] }));
}
